import styled from "styled-components";

export const Hr = styled.hr`
  border: 1px solid ${(props) => props.theme.color};
  width: 100%;
`;
